// Wraps a document page's header and tab content. Structuring's side panels push
// this element aside so the header's toolbar stays clear of the open panel.
export const DOCUMENT_PAGE_CONTENT_CLASS = 'document-page-content';
